<header class="toolbar" fxLayoutAlign="end center" fxLayout="row" fxHide fxShow.gt-sm>
  <button mat-button *ngFor="let subPage of subPages" routerLink="/{{subPage.path}}" [class.active]="isActive(subPage.path)">
    <mat-icon svgIcon="{{subPage.icon}}"></mat-icon>
    <span>{{subPage.name}}</span>
    <span class="active-bottom__border"></span>
    <span class="divider"></span>
  </button>
</header>
